import { render } from "./MyGlobalRadioProPrivacy.vue?vue&type=template&id=03b38108&scoped=true"
import script from "./MyGlobalRadioProPrivacy.vue?vue&type=script&lang=js"
export * from "./MyGlobalRadioProPrivacy.vue?vue&type=script&lang=js"

import "./MyGlobalRadioProPrivacy.vue?vue&type=style&index=0&id=03b38108&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03b38108"]])

export default __exports__